var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"alerts-actions-views",class:_vm.statusClass},[_c('i',{class:_vm.statusIcon})])])}
var staticRenderFns = []

export { render, staticRenderFns }